import React from "react";
import { Route, Switch } from "react-router-dom";
import { FETCH_EMS } from "../ems/EMsTypes";
import { FETCH_ENGINEERS } from "../engineers/EngineersTypes";
import { useRouteData } from "../redux/useRouteData";
import { FETCH_TEAMS } from "../teams/TeamsTypes";
import { CustomerForm } from "./CustomerForm";
import { CustomersPanel } from "./CustomersPanel";

const CUSTOMER_ROUTE_DATA = [
  FETCH_EMS,
  FETCH_ENGINEERS,
  FETCH_TEAMS,
];

export function CustomersPage() {
  useRouteData(CUSTOMER_ROUTE_DATA);

  return (
    <Switch>
      <Route path="/administration/customers/:id" strict={true}>
        <CustomerForm />
      </Route>
      <Route path="/administration/customers/" strict={true}>
        <CustomerForm />
      </Route>
      <Route path="/administration/customers">
        <CustomersPanel />
      </Route>
    </Switch>
  );
}
